import { FormTemplate } from './form-template.type';
import { FormParameters } from './form-parameters.type';

export interface RulesetDocumentContext {
    documentData?: any;
    fieldChanged?: string;
    originValue?: any;
    newValue?: any;
    oldValue?: any;
    templateId?: string;
    formParameters?: FormParameters;
    template?: FormTemplate;
    databaseMode?: string;
    isNew?: boolean;
}
